/**
 * Read CustomerAddresses.notes with temporary legacy fallback.
 * Drop shipperNotes/consigneeNotes fallback once FE is fully on notes.
 */
export function getCustomerAddressNotes(address) {
  if (!address) return '';
  if (address.notes != null && String(address.notes).trim() !== '') {
    return String(address.notes);
  }
  return [address.shipperNotes, address.consigneeNotes]
    .filter((v) => v != null && String(v).trim() !== '')
    .join('\n');
}
